import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

export function useMarketplacePacks() {
  return useQuery({
    queryKey: ["marketplace_packs"],
    queryFn: async () => (await api.get("/api/marketplace/packs")).data,
  });
}
